"use client";

import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface TypingIndicatorProps {
  className?: string;
}

export function TypingIndicator({ className }: TypingIndicatorProps) {
  const dotVariants = {
    animate: (i: number) => ({
      y: [0, -6, 0],
      opacity: [0.4, 1, 0.4],
      transition: {
        y: {
          delay: i * 0.15,
          duration: 0.6,
          repeat: Infinity,
          repeatDelay: 0.3,
          ease: "easeInOut" as const,
        },
        opacity: {
          delay: i * 0.15,
          duration: 0.6,
          repeat: Infinity,
          repeatDelay: 0.3,
          ease: "easeInOut" as const,
        },
      },
    }),
  };

  return (
    <div
      className={cn(
        "inline-flex items-center gap-2 px-3 py-1.5 rounded-full",
        "bg-dark-card/80 dark:bg-dark-card/80 bg-light-card/80",
        "border border-white/[0.06] dark:border-white/[0.06] border-black/[0.06]",
        className,
      )}
    >
      <span className="text-xs text-dark-text-secondary dark:text-dark-text-secondary text-light-text-secondary">
        Mengetik
      </span>
      <div className="flex items-center gap-[3px]">
        {[0, 1, 2].map((i) => (
          <motion.span
            key={i}
            custom={i}
            variants={dotVariants}
            animate="animate"
            className="inline-block w-[5px] h-[5px] rounded-full bg-gold"
          />
        ))}
      </div>
    </div>
  );
}
